export type DealerFilterCriteria = {
	Zone: string | null,
	City: string | null,
	Outlet: string | null
};


export type ExportCPFData = {
	SourceDealerKVPS: string | null,
	TargetDealerKVPS: string | null,
	cpfIds: number[],
	CreatedById: 0,
	CreatedByName: '',
};

export type DealerCode = {
	DealerKVPS: string | null,
};


export enum ExportCPFStatus { Success, Failure, NoDataFound }

export enum UserMessage {
	CPF_STATUS_UPDATE_ERROR = 'CPF_STATUS_UPDATE_ERROR',
	CPF_EMAIL_ERROR = 'CPF_EMAIL_ERROR'
}